module.exports = __webpack_public_path__ + "img/2.0e0dc712.jpg";